<div class="bg-[#FFF8F4] rounded-[4px] shadow-sm overflow-hidden">
    <div class="overflow-x-auto overflow-y-auto max-h-[60vh]">
        <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50 sticky top-0 z-10">
                <tr>
                    <th scope="col" class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                    <th scope="col" class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dirección MAC</th>
                    <th scope="col" class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Datos Unidad</th>
                    <th scope="col" class="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Ubicación</th>
                    <th scope="col" class="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
                @if (isLoading()) {
                    @for (item of [].constructor(5); track $index) {
                        <tr>
                            <td colspan="5" class="px-4 py-2">
                                <div class="animate-pulse flex items-center gap-4">
                                    <div class="h-3 bg-gray-200 rounded w-1/4"></div>
                                    <div class="h-3 bg-gray-200 rounded w-1/6"></div>
                                    <div class="h-3 bg-gray-200 rounded w-1/5"></div>
                                    <div class="h-3 bg-gray-200 rounded w-1/6"></div>
                                    <div class="h-3 bg-gray-200 rounded w-12"></div>
                                </div>
                            </td>
                        </tr>
                    }
                } @else if (beacons().length === 0) {
                    <tr>
                        <td colspan="5" class="text-center py-12">
                            <div class="flex flex-col items-center gap-4">
                                <div class="size-16 text-gray-400">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-full h-full">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z M13 16v-3a3 3 0 00-3-3H4m.4 14l1.738-6.957A1 1 0 017.1 15H16">
                                        </path>
                                    </svg>
                                </div>
                                <div class="text-center">
                                    <h3 class="text-sm font-medium text-gray-900">No hay beacons</h3>
                                    <p class="text-sm text-gray-500 mt-1">Comienza asociando un beacon a un vehículo.</p>
                                </div>
                                <a routerLink="/dashboard" class="inline-flex items-center gap-1 px-4 py-2 rounded-[4px] font-medium bg-[#F99C1E] text-white cursor-pointer transition-colors text-sm">
                                    <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                                    </svg>
                                    Mostrar vehículos
                                </a>
                            </div>
                        </td>
                    </tr>
                } @else {
                    @for (beacon of beacons(); track beacon.id) {
                        <tr [class]="'hover:bg-gray-50 transition-colors cursor-pointer border-l-4 border-l-transparent'" (click)="onSelectBeacon(beacon)">
                            <td class="px-4 py-2 whitespace-nowrap">
                                @if(beacon.reportDate) {
                                    <div class="text-xs text-gray-900">{{ formatDate(beacon.reportDate) }}</div>
                                    <span 
                                        class="px-2 py-0.5 rounded-[4px] text-xs font-medium" 
                                        [class]="{
                                            'bg-red-100': getTimeDiffCategory(beacon.reportDate, beacon.consultedAt) == 'days', 
                                            'text-red-800': getTimeDiffCategory(beacon.reportDate, beacon.consultedAt) == 'days',
                                            'bg-orange-100': getTimeDiffCategory(beacon.reportDate, beacon.consultedAt) == 'hours',
                                            'text-orange-800': getTimeDiffCategory(beacon.reportDate, beacon.consultedAt) == 'hours',
                                            'bg-green-100': getTimeDiffCategory(beacon.reportDate, beacon.consultedAt) == 'minutes',
                                            'text-green-800': getTimeDiffCategory(beacon.reportDate, beacon.consultedAt) == 'minutes',
                                        }">
                                            {{ getTimeDifference(beacon.reportDate, beacon.consultedAt) }}
                                    </span>
                                } @else {
                                    <span class="text-xs bg-red-100 text-red-800">Spook sin reportes</span>
                                }
                            </td>
                            <td class="px-4 py-2 whitespace-nowrap">
                                <div class="flex items-start flex-col gap-2">
                                    @if(beacon.macAddress) {
                                        <span class="text-sm font-medium text-gray-900">{{ beacon.macAddress }}</span>
                                        @if (beacon.trackingEnabled) {
                                            <span class="px-2 py-0.5 rounded-[4px] text-xs font-medium bg-red-100 text-red-800">Tracking ON</span>
                                        }
                                    } @else {
                                        <span class="text-xs bg-red-100 text-red-800">Spook sin Mac Address</span>
                                    }
                                </div>
                            </td>
                            <td class="px-4 py-2 whitespace-nowrap">
                                @if(beacon.assetName) {
                                    <div class="text-xs text-gray-900 truncate max-w-40"><b>Asset:</b> {{ beacon.assetName }}</div>
                                    <div class="text-xs text-gray-900 truncate max-w-40"><b>Vin:</b> {{ beacon.vin }}</div>
                                    <div class="text-xs text-gray-900 truncate max-w-40"><b>Holder:</b> {{ beacon.holderName }}</div>
                                } @else {
                                    <span class="text-xs bg-red-100 text-red-800">Spook sin asset</span>
                                }
                            </td>
                            <td class="px-4 py-2 whitespace-nowrap text-center">
                                @if(beacon.latitude && beacon.longitude) {
                                    <div class="flex items-center justify-center gap-1">
                                        <svg class="size-3 text-red-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                                        </svg>
                                        <span class="text-xs text-gray-700">{{ beacon.latitude }}, {{ beacon.longitude }}</span>
                                    </div>
                                } @else {
                                    <span class="text-xs bg-red-100 text-red-800">Spook sin posición</span>
                                }
                            </td>
                            <td class="px-4 py-2 whitespace-nowrap text-center">
                                <div class="flex items-center justify-center gap-1">
                                    @if(beacon.latitude && beacon.longitude) {
                                        <a
                                            [href]="getGoogleMapsUrl(beacon)"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Abrir en Google Maps"
                                            class="inline-flex items-center p-1.5 rounded-[4px] text-[#172C41] hover:bg-gray-100 cursor-pointer transition-colors"
                                        >
                                            <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                                            </svg>
                                        </a>
                                    }
                                    <button
                                        type="button"
                                        (click)="onEditBeacon(beacon); $event.stopPropagation()"
                                        title="Editar Spook"
                                        class="inline-flex items-center p-1.5 rounded-[4px] text-[#172C41] hover:bg-gray-100 cursor-pointer transition-colors"
                                    >
                                        <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>

    @if (totalRecords() > 0) {
        <div class="flex flex-col sm:flex-row items-center justify-between gap-4 px-6 py-3 bg-white border-t border-gray-200">
            <span class="text-sm text-gray-700">
                Mostrando {{ currentPageDisplay().first }} a {{ currentPageDisplay().last }} de {{ totalRecords() }} reportes
            </span>
            <div class="flex items-center gap-4">
                <div class="flex items-center gap-2">
                    <label for="rowsPerPage" class="text-sm text-gray-700">Filas por página:</label>
                    <select
                        id="rowsPerPage"
                        [value]="rows()"
                        (change)="onRowsPerPageChange($event)"
                        class="rounded-[4px] border border-gray-300 px-2 py-1 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E]"
                    >
                        @for (option of rowsPerPageOptions(); track option) {
                            <option [value]="option" [selected]="option === rows()">{{ option }}</option>
                        }
                    </select>
                </div>
                <div class="flex gap-1">
                    <button
                        (click)="onPrevPage()"
                        [disabled]="first() === 0"
                        class="px-3 py-1.5 rounded-[4px] text-sm font-medium border border-[#172C41] text-[#172C41] cursor-pointer transition-colors hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Anterior
                    </button>
                    <button
                        (click)="onNextPage()"
                        [disabled]="first() + rows() >= totalRecords()"
                        class="px-3 py-1.5 rounded-[4px] text-sm font-medium border border-[#172C41] text-[#172C41] cursor-pointer transition-colors hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Siguiente
                    </button>
                </div>
            </div>
        </div>
    }

    @if (showEditModal() && editingBeacon()) {
        <div class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 py-10">
            <div class="bg-[#FFF8F4] rounded-[4px] shadow-xl w-full max-w-lg mx-4">
                <div class="flex items-center justify-between px-6 pt-6 pb-2">
                    <h2 class="text-lg font-semibold text-[#172C41]">Editar Spook</h2>
                    <button
                        type="button"
                        (click)="onModalClose()"
                        class="inline-flex items-center p-1 rounded-[4px] text-gray-500 hover:bg-gray-100 cursor-pointer transition-colors"
                        aria-label="Cerrar"
                    >
                        <svg class="size-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
                <app-beacon-form
                    [id]="editingBeacon()!.id"
                    [beacon]="editingBeacon()!"
                    (formClose)="onBeaconUpdated()"
                />
            </div>
        </div>
    }
</div>
